import { type FC, type ReactNode } from "react";

import { clsx } from "clsx";

export type StackGap = "xs" | "sm" | "md" | "lg" | "xl";

const GAP_STYLE: Record<StackGap, string> = {
  xs: "space-y-0.5",
  sm: "space-y-1",
  md: "space-y-2",
  lg: "space-y-4",
  xl: "space-y-6",
};

export const Stack: FC<{
  children: ReactNode;
  gap?: StackGap;
  disabled?: boolean;
}> = ({ children, gap = "md", disabled = false }) => (
  <div className={clsx(GAP_STYLE[gap], disabled && "pointer-events-none")}>
    {children}
  </div>
);
